import { useCallback, useEffect, useRef, useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { assets } from "src/lib/utils/assets";

export default function FileDropZone({
  label = "Upload File",
  accept,
  maxSize = 2000,
  inputId,
  limit = Number.MAX_VALUE,
  values,
  onChange,
}) {
  const dropZoneRef = useRef();
  const [files, setFiles] = useState([]);

  function preventEvent(event) {
    event.preventDefault();
  }

  const validateAndStoreFiles = useCallback(
    (files) => {
      if (files.length == 0) {
        onChange(
          [],
          `Invalid file(s) upload, expected ${accept} or files to large ${
            (maxSize * 2) / 1000
          } mb expected.`
        );
      }

      if (files.length > limit) {
        onChange([], `You can only upload ${limit} file`);
        return;
      }

      files.forEach((item, index) => {
        if (limit == 1 && index == 0) {
          setFiles([item]);
          return;
        }
        if (index < limit) {
          setFiles((prev) => [...prev, item]);
        }
      });
    },
    [accept, limit, maxSize]
  );
  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();

      const droppedItems = [...event.dataTransfer.items]
        .filter((item) => item.kind === "file")
        .map((file) => file.getAsFile())
        .filter((pred) => {
          return pred.type.includes("pdf");
        });

      validateAndStoreFiles(droppedItems);
    },
    [validateAndStoreFiles]
  );

  useEffect(() => {
    window.addEventListener("dragover", preventEvent);
    window.addEventListener("drop", preventEvent);

    return () => {
      window.removeEventListener("dragover", preventEvent);
      window.removeEventListener("drop", preventEvent);
    };
  }, []);

  useEffect(() => {
    const current = dropZoneRef.current;

    if (!current) return;

    current.addEventListener("drop", handleDrop);

    return () => {
      current.removeEventListener("drop", handleDrop);
    };
  }, [dropZoneRef, handleDrop]);

  useEffect(() => {
    onChange(files, undefined);
  }, [files]);

  const handleJDChange = (e) => {
    const files = e.currentTarget.files;

    if (files.length < 1) return;

    validateAndStoreFiles([...files]);

    return;
  };

  return (
    <>
      <div ref={dropZoneRef} className="flex flex-col gap-3 justify-center">
        <div className=" flex justify-center px-6 pt-5 pb-6 border-2 border-gray-600 border-dashed rounded-md">
          <div className="space-y-1 text-center">
            <svg
              className="mx-auto h-12 w-12 text-muted-foreground"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="flex text-sm text-muted-foreground">
              <label
                htmlFor={inputId}
                className="relative cursor-pointer bg-white rounded-md font-medium text-[#f49038] hover:text-[#f49038] focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#f49038]"
              >
                <span>{label}</span>{" "}
                <span className="text-gray-700 cursor-auto">
                  or drag and drop
                </span>
                <input
                  id={inputId}
                  name={inputId}
                  type="file"
                  accept={accept}
                  className="sr-only"
                  onChange={handleJDChange}
                />
              </label>
            </div>
            <p className="text-xs text-muted-foreground">.pdf only less than 2MB</p>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          {values.map((file, index) => {
            const isPdf = file.type.includes("pdf");
            return (
              <div
                key={index}
                className="flex items-center w-full bg-surface px-4 rounded-md"
              >
                <img width={40} height={40} src={assets.pdfIcon} alt="PDF Icon" />
                <div className="flex-1">
                  <p className="p-3">{file.name}</p>
                  {/* <p>{convertKbToMb(file.size)}</p> */}
                </div>
                <MdOutlineCancel
                  onClick={() => {
                    setFiles((prev) =>
                      prev.filter((pred) => pred.name != file.name)
                    );
                    console.log("C", file.name);
                  }}
                  className="cursor-pointer transition-all duration-250 hover:scale-[1.4]"
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

function convertKbToMb(kb) {
  return kb / 0.0009765625 + " mb";
}
